import { render, staticRenderFns } from "./RelatedFragments.vue?vue&type=template&id=4cc9ef79&scoped=true"
import script from "./RelatedFragments.vue?vue&type=script&lang=ts"
export * from "./RelatedFragments.vue?vue&type=script&lang=ts"
import style0 from "./RelatedFragments.vue?vue&type=style&index=0&id=4cc9ef79&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc9ef79",
  null
  
)

export default component.exports